import React from 'react';
import clsx from 'clsx';
import type { Dealer } from '../../types/dealers.types';
import { Button, Card, CardContent, CardMedia, CardTitle, Mapper } from '@shared/components';

const CARD_CLASSES = 'flex flex-col hover:bg-mp-background';
const SELECTED_CARD_CLASSES = 'border-mp-primary ring-1 ring-mp-primary';
const BODY_CLASSES = 'flex flex-auto flex-col';
const LINE_CLASSES = 'grow text-sm';
const ACTIONS_CLASSES = 'flex flex-wrap items-start justify-end gap-2';

interface DealerCardProps {
    dealer: Dealer;
    className?: string;
    onSelectDealer: (dealer: Dealer) => void;
    isSelected?: boolean;
}

export const DealerCard: React.FC<DealerCardProps> = ({
    dealer,
    className,
    onSelectDealer,
    isSelected = false,
}) => {
    const dealerPosition: [number, number] = [Number(dealer.latitude), Number(dealer.longitude)];

    return (
        <Card className={clsx(CARD_CLASSES, isSelected && SELECTED_CARD_CLASSES, className)}>
            <CardMedia>
                <Mapper
                    markers={[
                        {
                            position: dealerPosition,
                            popupTitle: dealer.name,
                            popupContent: dealer.address_line_1,
                        },
                    ]}
                    zoom={19}
                    center={dealerPosition}
                />
            </CardMedia>
            <CardContent className={BODY_CLASSES}>
                <CardTitle>{dealer.name}</CardTitle>
                <p className={LINE_CLASSES}>
                    {dealer.address_line_1}
                    {dealer.address_line_2 && `, ${dealer.address_line_2}`}
                </p>
                <p className={LINE_CLASSES}>{dealer.city}</p>
                <p className={LINE_CLASSES}>{dealer.postcode}</p>
                <div className={ACTIONS_CLASSES}>
                    <Button
                        size="xs"
                        variant={isSelected ? 'outline' : 'primary'}
                        onClick={() => onSelectDealer(dealer)}
                    >
                        {isSelected ? 'Selected' : 'Select'}
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};
